<template>
  <div id="topHead">
    <div class="headView_top">
      <p class="applyTitle">项目名称：{{ basicParams.project_name }}</p>
      <div class="headView_top_btn" v-if="allSubmit">
        <div>
          <button class="btnColorOne" type="button" @click="$router.go(-2)">
            退出
          </button>
        </div>
        <div style="margin-left: 40px;">
          <button
            class="btnColorTwo"
            type="button"
            @click="upShow('tips', undefined, '1')"
          >
            提交申报记录
          </button>
          <div class="btnTips">
            <img
              src="../../assets/img/login/注释.png"
              style="width: 18px;height: 18px;"
            />
            <p>一旦提交，不可修改，请谨慎操作</p>
          </div>
        </div>
      </div>
    </div>
    <div class="headClass">
      <p>项目类型：{{ basicParams.project_type_name }}</p>
      <p>申请时间：{{ basicParams.apply_start }}-{{ basicParams.apply_end }}</p>
      <!-- <p>审核时间：{{basicParams.app_start}}-{{basicParams.app_end}}</p> -->
    </div>

    <div class="content_view">
      <div class="contentLeft">
        <p
          v-for="(item, index) in navList"
          :key="index"
          @click="changeTab(index)"
          :class="navIndex === index ? 'tabActive' : ''"
        >
          {{ item }}
        </p>
      </div>
      <div class="contentRight">
        <div v-show="navIndex === 0">
          <p class="view_head">申报须知</p>
          <!-- pdf -->
          <div style="height: 650px;overflow-y: scroll">
            <pdfVue v-if="require_pdf_url" :pdf_url="require_pdf_url"></pdfVue>
          </div>
          <div style="margin-bottom: 5px;text-align: center;margin-top: 5px">
            <el-button :type="primary" @click="doReady" :disabled="disabled">{{
              btnContent
            }}</el-button>
          </div>
        </div>
        <div v-show="navIndex === 1">
          <p class="view_head">评价办法</p>
          <!-- pdf -->
          <div style="height: 650px;overflow-y: scroll">
            <pdfVue
              v-if="selection_pdf_url"
              :pdf_url="selection_pdf_url"
            ></pdfVue>
          </div>
          <div style="margin-bottom: 5px;text-align: center;margin-top: 5px">
            <el-button :type="primary" @click="doReady2" :disabled="disabled">{{
              btnContent
            }}</el-button>
          </div>
        </div>

        <div v-show="navIndex === 2">
          <!-- 基本信息 -->
          <zjManager
            :project_code="project_code"
            @reciveData="reciveData"
            :datas="levelOne"
          ></zjManager>
        </div>

        <div v-show="navIndex === 3">
          <!-- 获奖信息 -->
          <zjManagerAward ref="zjAward" :datas="levelTwo"></zjManagerAward>
        </div>

        <div class="uploadContent" v-show="navIndex === 4">
          <div>
            <p class="view_head">资料上传</p>
            <div
              class="uploadList"
              v-for="(item, index) in uploadData.title"
              :key="index"
            >
              <div class="uploadList_head">
                <p>
                  <span
                    style="color: red;margin-right: 10px;"
                    v-show="requiredList[index] === 1"
                    >*</span
                  >{{ item }}
                </p>
                <div :class="[index == 6 ? 'over_list' : '', 'head_list']">
                  <!-- 点击生成 -->
                  <img
                    v-if="index === 0"
                    src="../../assets/img/main/download.png"
                    style="width: 20px;height: 20px;"
                  />
                  <p
                    v-if="index === 0"
                    @click="downLoadFile"
                    style="margin-right: 20px;"
                  >
                    点击生成
                  </p>
                  <!-- 点击上传 -->

                  <img
                    v-if="index != 6"
                    src="../../assets/img/main/upload.png"
                    style="width: 20px;height: 20px;"
                  />
                  <p @click="upShow('upload', index)" v-if="index != 6">
                    点击上传
                  </p>
                  <div class="inner_list" v-if="index == 6">
                    <img
                      src="../../assets/img/main/upload.png"
                      style="width: 20px;height: 20px;"
                    />
                    <p @click="upShow('upload', index)">点击上传(2022年)</p>
                  </div>
                  <div class="inner_list" v-if="index == 6">
                    <img
                      src="../../assets/img/main/upload.png"
                      style="width: 20px;height: 20px;"
                    />
                    <p @click="upShow('upload', index)">点击上传(2023年)</p>
                  </div>
                  <div class="inner_list" v-if="index == 6">
                    <img
                      src="../../assets/img/main/upload.png"
                      style="width: 20px;height: 20px;"
                    />
                    <p @click="upShow('upload', index)">点击上传(2024年)</p>
                  </div>
                </div>
              </div>
              <div class="uploadList_mid">
                <p>{{ uploadData.tips[index] }}</p>
              </div>
              <div class="uploadList_bot">
                <div
                  class="inner_upload"
                  v-for="(item, key) in uploadList[index]"
                  :key="key"
                  @click="showPriv(item)"
                >
                  <p>{{ item.name ? item.name : item.data_name }}</p>
                  <img
                    src="../../assets/img/login/cuowu.png"
                    @click.stop="deleteUpload(key, index)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="uploadBtn" v-show="navIndex == 2">
      <el-button type="primary" @click="basicInfo">保存</el-button>
    </div>
    <div class="uploadBtn" v-show="navIndex == 3">
      <el-button type="primary" @click="getAwardInfo">保存</el-button>
    </div>
    <div
      class="uploadBtn"
      v-show="navIndex == 4"
      style="display: flex;flex-flow: column;"
    >
      <div class="content_btn">
        <p>资料上传后请点击保存</p>
      </div>
      <el-button type="primary" @click="setUploadFile">保存</el-button>
    </div>
    <!-- 弹窗 -->
    <addDialog ref="download" @submitSuccess="submitSuccess"></addDialog>
  </div>
</template>

<script>
// getUploadFile上传文件附件
import {
  getProjectDetail,
  getWinningInfo,
  getUploadFile,
  getDataItem,
  addZjManager,
} from "../../api/moudles/manager.js";
import { API_DOMAIN } from "../../api/api.js";
import { vaildte } from "../../utils/validate.js";
import pdfVue from "./components/pdfVue.vue";
import addDialog from "./components/addDialog.vue";

import zjManager from "./components/zjManager_apply.vue";
import zjManagerAward from "./components/zjManager_award.vue";

export default {
  components: {
    addDialog,
    pdfVue,
    zjManager,
    zjManagerAward,
  },
  data() {
    return {
      makeShow: 0,
      basicMsg: {},
      // 质量小组基本信息
      disabled: false,
      projectType: "",
      basicParams: {},
      navIndex: 0,
      newnavIndex: 0,
      primary: "primary",
      spanWidth: "180px",
      navList: ["申报须知", "评价办法", "基本信息", "获奖信息", "资料上传"],
      // 基本信息的
      req_num_code: "",
      project_code: "",
      // 基本信息表单
      levelOne: {},
      // 基本信息表单
      newForm: {
        recommend_unit: "",
        company_name: "",
        province: "",
        city: "",
        // area:'',
        address: "",
        enp_contact_name: "",
        enp_contact_phone: "",
        real_name: "",
        sex: "",
        birth_date: "",
        politic: "",
        id_card: "",
        title: "",
        education: "",
        major: "",
        post: "",
        join_work_time: "",
        level: "",
        req_num: "",
        // certificate_num: '',
        headImg: "",
      },
      formName: {
        recommend_unit: "推荐单位",
        company_name: "申报企业名称",
        province: "省/市/区",
        // city:'',
        // area:'',
        address: "详细地址",
        enp_contact_phone: "申报企业联系电话",
        enp_contact_name: "申报企业联系人",
        real_name: "姓名",
        sex: "性别",
        id_card: "身份证",
        birth_date: "出生年月",
        politic: "政治面貌",
        education: "最高学历",
        join_work_time: "参加工作时间",
        title: "专业技术职称",
        post: "职务",
        headImg: "个人照片",
        major: "所学专业",
        level: "建造师资质等级及主项专业",
        req_num: "注册证书编号",
        // certificate_num: '继续教育证书编号',
      },
      // 获奖信息
      project_app_num: "",
      levelTwo: [],
      // 申报须知
      require_pdf_url: "",
      // 评价办法
      selection_pdf_url: "",
      btnContent: "我已阅读",
      totalTime: 15,
      canClick: true, //添加canClick
      // 模板下载列表
      modelList: [],
      // 上传文件列表
      clickIndex: 0,
      uploadList: [],
      // 最终提交
      allSubmit: false,
      // 资料上传内容
      uploadData: "",
      // 必填信息
      requiredList: [],
    };
  },
  created() {
    // 限制阅读
    // this.countDown()
    // 无id返回
    if (!this.$route.params.projectCode) {
      this.$router.go(-1);
      return;
    }
    const projectCode = this.$route.params.projectCode;
    const projectType = this.$route.params.type;
    const isAdd = this.$route.params.isAdd;
    this.projectType = projectType;
    this.project_code = projectCode;
    // 获取上传文件
    this.getDataItem(projectType);
    // 获取pdf
    this.getProjectdetail(projectCode, isAdd);
    // // 获取项目类型字段
    // // 绑定project_code
    // // this.levelOne.project_code = this.$route.params.projectCode
  },
  methods: {
    // 承诺书
    downloadOne() {
      const url = `${API_DOMAIN}/adminapi/static/chengnuoshu.xlsx`;
      window.open(url);
    },
    // 评审表
    downloadTwo() {
      const url = `${API_DOMAIN}/adminapi/static/pingshen.xlsx`;
      window.open(url);
    },
    // 接受回传数据
    reciveData(data) {
      const [name, value] = data;
      this.newForm[name] = value;
    },
    // //获取上传文件
    async getDataItem(type) {
      await getDataItem({
        data: {
          type,
        },
        success: (res) => {
          // console.log('上传文件', res)
          this.uploadData = res.data;
          this.requiredList = res.data.required;
        },
      });
    },
    countDown() {
      if (!this.canClick) return; //改动的是这两行代码
      this.canClick = false;
      this.btnContent = "我已阅读" + "(" + this.totalTime + "s)";
      this.disabled = true;
      let clock = window.setInterval(() => {
        this.totalTime--;
        this.btnContent = "我已阅读" + "(" + this.totalTime + "s)";
        if (this.totalTime < 0) {
          window.clearInterval(clock);
          this.btnContent = "我已阅读";
          this.disabled = false;
          this.totalTime = 15;
          this.canClick = true; //这里重新开启
        }
      }, 1000);
    },
    doReady() {
      this.makeShow++;
      this.navIndex++;
      this.countDown();
    },
    doReady2() {
      this.makeShow++;
      this.navIndex++;
    },
    // 下载pdf模板
    downLoadFile() {
      if (!this.project_app_num) {
        this.$message.error("请先提交基本信息");
        return;
      }
      const url = `${API_DOMAIN}/proapi/down/download-basic-msg?type=${
        this.projectType
      }&project_app_num=${this.project_app_num}&project_name=${
        this.basicParams.project_name
      }`;
      window.open(url);
    },

    // 获取质量小组获奖信息
    async getAwardInfo() {
      if (!this.project_app_num) {
        this.$message.error("请先提交基本信息");
        return;
      }
      if (this.project_app_num) {
        let newData = this.$refs.zjAward.getData();
        newData.forEach((item) => {
          item.project_app_num = this.project_app_num;
          if (!item.number) {
            item.number = "0";
          }
        });
        const params = {
          awardJson: newData,
        };
        await getWinningInfo({
          data: params,
          success: (res) => {
            if (res.code === 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              setTimeout(() => {
                this.navIndex++;
              }, 800);
              // 自定义判断获奖信息 题没提交成功
            } else {
              this.$message.error(res.msg);
            }
          },
          fail: (err) => {
            console.log(err);
          },
        });
      }
    },
    // 保存的图片删除
    deleteUpload(key, index) {
      this.$confirm("此操作将删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.uploadList[index].splice(key, 1);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 预览
    showPriv(e) {
      window.open(e.url);
    },
    // 上传文件附件保存
    async setUploadFile() {
      if (!this.project_app_num) {
        this.$message.error("请先提交基本信息");
        return;
      }
      for (let i = 0; i < this.requiredList.length; i++) {
        if (this.requiredList[i] === 1) {
          if (
            this.uploadList[i] == undefined ||
            this.uploadList[i].length == 0
          ) {
            this.$message.error("有必填资料未完成上传");
            return;
          }
        }
      }
      let newArray = this.uploadList.filter(function(s) {
        return s && s.length;
      });
      if (!newArray.length) {
        this.$message.error("请先上传文件");
        return;
      }
      if (newArray.length < 2) {
        this.$message.error("至少上传两条");
        return;
      }
      let dataJson = [];
      this.uploadList.forEach((items, key) => {
        items.forEach((item, index) => {
          let data = {};
          data["data_name"] = item.name ? item.name : item.data_name;
          data["type"] = key + 1;
          data["stored_path"] = item.url ? item.url : item.stored_path;
          dataJson.push(data);
        });
      });
      const params = {
        dataJson: dataJson,
        project_app_num: this.project_app_num,
      };
      await getUploadFile({
        data: params,
        success: (res) => {
          // console.log(res)
          if (res.code === 200) {
            this.$message({
              message: res.msg + ",现在可以确认提交",
              type: "success",
            });
            this.allSubmit = true;
            let a = document.createElement("a");
            a.style.display = "none";
            a.href = "#topHead";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          } else {
            this.$message.error(res.msg);
          }
        },
      });
    },
    //接受点击上传回穿
    submitSuccess(e) {
      if (this.uploadList[this.clickIndex]) {
        let newList = [...this.uploadList[this.clickIndex], ...e];
        this.$set(this.uploadList, this.clickIndex, newList);
        return;
      }
      this.$set(this.uploadList, this.clickIndex, e);
    },
    // 切换tab栏/
    changeTab(index) {
      this.navIndex = index;
      // if (this.makeShow > 1) {
      // 	this.navIndex = index
      // } else {
      // 	this.$message.error('还没完成阅读')
      // }
    },
    // 获取必填警示
    requireSubmit(params, nameList) {
      //如果数据是对象形式
      let upString = [];
      Object.keys(params).forEach((item, index) => {
        if (
          params[item] == "" ||
          params[item] == undefined ||
          params[item] == null
        ) {
          if (nameList[item]) {
            upString.push(item);
          }
        }
      });
      if (!upString.length) {
        return false;
      } else {
        this.$message.error(`${nameList[upString[0]]}未填写`);
        return true;
      }
      // 如果数据是数组形式
    },
    // 获取项目明细
    async getProjectdetail(project_code, isAdd) {
      await getProjectDetail({
        data: {
          project_code,
          type: "10",
          isAdd: isAdd,
        },
        success: (res) => {
          // console.log('获取项目明细', res.data)
          // 项目信息
          this.basicParams = res.data;

          // 基本信息
          if (res.data.basicMsg) {
            this.levelOne = res.data.basicMsg;
            this.newForm = {
              ...res.data.basicMsg,
            };
            this.project_app_num = res.data.basicMsg.project_application_id;
            delete this.newForm.project_application_id;
          } else {
            // 申报企业名称
            if (res.data.company.name) {
              const newOne = {
                ...this.newForm,
              };
              newOne.company_name = res.data.company.name;
              this.levelOne = newOne;
              this.newForm.company_name = res.data.company.name;
            }
          }
          // 获奖信息
          if (res.data.award_list) {
            this.levelTwo = res.data.award_list;
          }

          // 申报须知PDF
          this.require_pdf_url = res.data.require_pdf_url;
          // 评价办法PDF
          this.selection_pdf_url = res.data.selection_pdf_url;

          // 文件上传
          if (res.data.data_list) {
            const uploadList = res.data.data_list;
            let newUploadList = [];
            uploadList.forEach((item, index) => {
              newUploadList[Number(item.type) - 1] = [];
            });
            uploadList.forEach((item, index) => {
              newUploadList[Number(item.type) - 1].push(item);
            });
            this.uploadList = newUploadList;
          }
        },
      });
    },
    // 提交获奖信息-已删除
    // 模板下载弹窗
    upShow(type, index, status) {
      this.clickIndex = index;
      if (type === "muban") {
        const params = {
          type,
          download: this.modelList,
        };
        this.$refs["download"].showAdd(params);
      } else if (type === "tips") {
        const params = {
          type,
          project_app_num: this.project_app_num,
          status,
        };
        this.$refs["download"].showAdd(params);
      } else {
        sessionStorage.setItem("dataUpload", index);
        if (this.projectType === "2" && index === 1) {
          const params = {
            type,
            project: true,
          };
          this.$refs["download"].showAdd(params);
        } else {
          if (!this.project_app_num) {
            this.$message({
              message: "请先完成基本信息提交",
              type: "error",
            });
            return;
          } else {
            const params = {
              type,
              project_app_num: this.project_app_num,
              click_index: index,
            };
            this.$refs["download"].showAdd(params);
          }
        }
      }
    },
    // 基本信息申报
    async basicInfo() {
      const params = {
        ...this.newForm,
      };
      if (this.project_app_num) {
        params.project_app_num = this.project_app_num;
      }
      params.project_code = this.project_code;
      // 验证各个工程的表单
      if (this.requireSubmit(params, this.formName)) {
        return;
      }
      // 身份证号码验证
      if (!vaildte.isIdCard(params.id_card)) {
        this.$message({
          message: "身份证号填写不正确",
          type: "error",
        });
        return false;
      }
      await addZjManager({
        data: params,
        success: (res) => {
          if (res.code === 200) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.project_app_num = res.data.project_app_num;
            setTimeout(() => {
              this.navIndex++;
            }, 800);
          } else {
            if (
              res.data.project_app_num &&
              res.data.project_app_num !== this.project_app_num
            ) {
              this.project_app_num = res.data.project_app_num;
            }
            this.$message.error(res.msg);
          }
        },
      });
    },
  },
};
</script>

<style scoped>
.over_list {
  display: flex;
  flex-flow: column;
}
.inner_list {
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnColorOne {
  background-color: #e6a23c;
}

.btnColorTwo {
  background-color: #1890ff;
}

/* 每个上传文件的样式 */
.inner_upload {
  position: relative;
  min-height: 40px;
  margin: 0 10px;
  /* width: 100px; */
  /* overflow: scroll; */
}

.inner_upload p {
  color: #1890ff;
}

.inner_upload img {
  border-radius: 50%;
  position: absolute;
  right: 0;
  top: 0;
  width: 15px;
  height: 15px;
  cursor: pointer;
}

.headView_top_btn {
  position: relative;
  margin-right: 125px;
  display: flex;
}

.btnTips {
  margin-top: 10px;
  display: flex;
  position: absolute;
  width: 350px;
  align-items: center;
}

.btnTips p {
  margin-left: 10px;
  font-size: 13px;
  color: #fe2c54;
}

/* 上传样式 */
.uploadBtn {
  margin-top: 60px;
  margin-bottom: 60px;
  display: flex;
  margin-left: 41.5%;
}

.uploadBtn button {
  width: 140px;
}

.uploadHead {
  display: flex;
  position: absolute;
  align-items: center;
  left: 255px;
}

.uploadHead p {
  margin-left: 10px;
  color: #1890ff;
  cursor: pointer;
}

.uploadList {
  border: 1px solid #f0f0f0;
  width: 90%;
  margin-top: 30px;
  margin-left: 5%;
}

.uploadList_head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 40px;
  padding: 0 40px 0 10px;
  line-height: 40px;
  font-size: 14px;
  flex-wrap: wrap;
  border-bottom: 1px solid #f0f0f0;
}

.uploadList_head p {
  text-align: left;
}

.head_list {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.head_list p {
  margin-left: 10px;
}

.head_list p:hover {
  color: #1890ff;
  text-decoration: underline;
}

.uploadList_mid {
  width: 90%;
  min-height: 30px;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  align-content: space-around;
  justify-content: flex-start;
}

.uploadList_mid p {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
  text-align: left;
  text-indent: 2em;
  padding: 10px;
}

.uploadList_bot {
  width: 70%;
  min-height: 30px;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  align-content: space-around;
  justify-content: flex-start;
}

.uploadList_bot p {
  display: inline-block;
  height: 40px;
  line-height: 40px;
  color: #1890ff;
  text-decoration: underline;
  margin: 0 20px;
  cursor: pointer;
}

/* 上传样式 */
.uploadContent {
  padding-bottom: 60px;
}

.inputList {
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
}

.titleLeft {
  margin-left: 50px;
}

.view_head {
  font-size: 18px;
  font-weight: 600;
  margin-top: 20px;
}

.midflex {
  display: flex;
  width: 90%;
  height: 50px;
  margin-left: 5%;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #eee;
}

.newAddBtn {
  width: 100%;
  display: flex;
  height: 70px;
  align-items: center;
  justify-content: center;
}

.headView {
  display: flex;
  flex-flow: column;
  align-items: flex-start;
}

.headView_top {
  width: 1350px;
  display: flex;
  justify-content: space-between;
}

.headView_top button {
  width: 100px;
  height: 35px;
  color: white;
  line-height: 35px;
  cursor: pointer;
}

.applyTitle {
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #000000;
}

.applyTitle {
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #000000;
}

.headClass {
  display: flex;
  margin-top: 10px;
}

.headClass p {
  margin-right: 40px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}

/* 申报 */
.content_view {
  margin-top: 20px;
  max-width: 1350px;
  min-height: 350px;
  /* min-height: 750px; */
  display: flex;
  border: 1px solid #f0f0f0;
}

.contentLeft {
  width: 200px;
}

.contentLeft p {
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 500;
  color: #333333;
  background-color: #fafafa;
  cursor: pointer;
}

.contentRight {
  width: calc(100% - 200px);
}

.tabActive {
  background: #e6f7ff !important;
  color: #6ea7ff !important;
  border-right: 2px solid #0077ff;
}

.content_btn {
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  margin-bottom: 30px;
}

.content_btn p {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #fe2c54;
}

.content_btn button {
  width: 150px;
  margin-top: 40px;
  margin-left: 440px;
}

.specialView {
  width: 720px;
  display: flex;
  align-items: center;
}

.specialView input {
  margin-left: 20px;
  width: 100%;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 500;
  letter-spacing: 1px;
  border-bottom: 1px solid #dbdbdb;
}

.specialView input::placeholder {
  color: #b5b5b5;
}

.dash_bottom {
  margin-top: 30px;
  margin-bottom: 20px;
  border-bottom: 1px solid #dbdbdb;
  margin-left: 120px;
  height: 1px;
  width: 81%;
}

/* gridtable */
table.gridtable {
  font-family: verdana, arial, sans-serif;
  font-size: 14px;
  color: #333333;
  border-width: 1px;
  border-color: #666666;
  border-collapse: collapse;
  margin: auto;
}

table.gridtable th {
  border-width: 1px;
  padding: 12px;
  border-style: solid;
  border-color: #666666;
  background-color: #dedede;
}

table.gridtable td {
  border-width: 1px;
  padding: 22px;
  border-style: solid;
  border-color: #666666;
  background-color: #ffffff;
}

table.gridtable .el-input__inner {
  border: none;
}

/* /gridtable */
</style>
